import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"


const __default__ = {
    name: "ClientIconsBeforeNameTargetTooltip"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {}
  },
  setup(__props: any) {

let props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.userdata.targetReasons, (reason, key) => {
    return (_openBlock(), _createElementBlock("div", {
      key: key,
      class: _normalizeClass(key > 0 ? 'mt-2' : null)
    }, _toDisplayString(reason.reason), 3))
  }), 128))
}
}

})